<template>
  <div class="view-list">
    <div class="comp-list">
      <div v-if="['men','youth_men','mixed','youth_mixed','foreign_men'].includes(currentTeam)" class="list athlete">
        <div class="box-border">
          <div class="player-title">男队球员</div>
          <div class="select-checkbox" @click="onCheckMenPlayersChange()">
            <img v-if="men_players_checked" class="select-icon" src="../assets/selected.png">
            <img v-else class="select-icon" src="../assets/unselected.png">
            <div class="select-text">全选</div>
          </div>
        </div>

        <div class="list-content scroll-box">
          <div v-for="item in males" :key="item.player_id" class="list-item" @click="handleItemSelect('player',item)">
            <div class="name athlete"
                 :class="{ 'retired-athlete': item.is_retired }"
            >{{item.player_name}}<span v-if="item.is_retired">(退)</span></div>
            <img v-if="item.selected" class="icon" src="../assets/selected.png">
            <img v-else class="icon" src="../assets/unselected.png">
          </div>
        </div>
      </div>
      <div v-if="['women','youth_women','mixed','youth_mixed','foreign_women'].includes(currentTeam)" class="list athlete">
        <div class="box-border">
          <div class="player-title">女队球员</div>
          <div class="select-checkbox" @click="onCheckWomenPlayersChange()">
            <img v-if="women_players_checked" class="select-icon" src="../assets/selected.png">
            <img v-else class="select-icon" src="../assets/unselected.png">
            <div class="select-text">全选</div>
          </div>
        </div>
        <div class="list-content scroll-box">
          <div v-for="item in females" :key="item.player_id" class="list-item" @click="handleItemSelect('player',item)">
            <div class="name athlete"
                 :class="{ 'retired-athlete': item.is_retired }">{{item.player_name}}<span v-if="item.is_retired">(退)</span></div>
            <img v-if="item.selected" class="icon" src="../assets/selected.png">
            <img v-else class="icon" src="../assets/unselected.png">
          </div>
        </div>
      </div>
      <div class="list competition">
        <div class="box-border">
          <div class="competition-title">比赛列表</div>
          <div class="select-competitions">
            <a-select v-model="default_value" style="width: 100px; height: 40px; font-size: 14px;" :options="options" @change="handleSelection"></a-select>
          </div>
          <div class="all-competitions">
            <div class="select-checkbox" @click="onCheckAllCompetitionsChange()">
              <img v-if="competitions_checked" class="select-icon" src="../assets/selected.png">
              <img v-else class="select-icon" src="../assets/unselected.png">
              <div class="select-text">全选</div>
            </div>
          </div>
        </div>
        <div class="list-box scroll-box">
          <div v-for="(list,index) in displayed_competitions" :key="index" class="list-content competition">
            <div v-for="item in list" :key="item.match_id" class="list-item comp-list-item"  @click="handleItemSelect('match',item)">
              <div class="name-info">
                <div v-if="item.has_score" class="name">
                  {{`${item.match_name} ${item.location}`}}
                  <span v-if="item.has_archived && false" style="color: #BF936B">{{`(档)`}}</span>
                  <span v-else></span>
                </div>
                <div v-else-if="$store.state.editMode" class="name"  style="color: #BF936B">
                  {{`${item.match_name} ${item.location}`}}
                </div>
                <div v-else class="name">
                  {{`${item.match_name} ${item.location}`}}
                </div>


                <div class="time">
                  {{`${item.start_date.join('/')}-${item.end_date.join('/')}`}}
                </div>
              </div>
              <img v-if="item.selected" class="icon" src="../assets/selected.png">
              <img v-else class="icon" src="../assets/unselected.png">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <a-button v-if="currentTeam!=='foreign_men' && currentTeam!=='foreign_women' " class="btn" type="primary" @click="handleConfirm">确认</a-button>
    </div>
  </div>
</template>

<script>
import { getTeamMatches, getTeamPlayers, updateTeamMatchSelection, updateTeamPlayerSelection, updateAllCompetitionsSelection, updateAllPlayersSelection } from '../api'
import { teamOptions } from '../utils/common'
import { getUserTeam } from '../api/index'
// import {message} from "ant-design-vue";
import { ref } from 'vue';
import utils from '../utils/cardIcon.js'

export default {
  name: 'List',
  components: {
  },
  data(){
    return {
      competitions: [],
      males: [],
      females: [],
      default_value: '2026',
      options: ref([
          {
              value: 'all',
              label: '所有年份',
          },
          {
              value: '2023',
              label: '2023年',
          },
          {
              value: '2024',
              label: '2024年',
          },
        {
          value: '2025',
          label: '2025年',
        },{
          value: '2026',
          label: '2026年',
        }
      ]),
      year: 'all',
      competitions_checked: false,
      men_players_checked: false,
      women_players_checked: false,
      displayed_competitions: []
    }
  },
  computed: {
    currentTeam(){
      return this.$store.state.currentTeam
    }
  },
  mounted() {
    // if(['foreign_men','foreign_women'].includes(this.$store.state.currentTeam)){
    //   message.info("外协会对手分析仅支持在\"分析\"界面查看，请在此页面选择国内球队。")
    //   // this.$store.commit('setCurrentTeam', 'women')
    // }
    this.getTeamList()
    this.getOptions()
  },
  watch: {
    currentTeam() {
      this.getOptions()
    }
  },
  methods: {
    async getTeamList() {
      const response = await getUserTeam()
      if(response.status === 200) {
        if(response.data.success) {
          const teams = teamOptions.filter(item=>
            response.data.teams.includes(item.value))
          this.$store.commit('setCurrentTeamList', teams)
          if (!this.$store.state.currentTeam) {
            this.$store.commit('setCurrentTeam', teams[0]?.value)
          }
        }
      }
    },
    isFutureDate(y,m,d){
      let thisDay = new Date(y,m,d)
      let today = new Date()
      // console.log(thisDay,today,thisDay<today)
      return thisDay > today
    },
    getOptions() {
      if(this.currentTeam){
        this.getPlayerOptions()
        this.getMatchesOptions()
      }
    },
    async getPlayerOptions() {
      const response = await getTeamPlayers(this.currentTeam)
      if(response.status === 200) {
        if(response.data.success) {
          const players = response.data.players
          this.males = players.filter(item=>['men','youth_men','foreign_men'].includes(item.type))
          this.females = players.filter(item=>['women','youth_women','foreign_women'].includes(item.type))
          this.men_players_checked = this.players_is_all_checked(players.filter(item=>['men','youth_men','foreign_men'].includes(item.type)))
          this.women_players_checked = this.players_is_all_checked(players.filter(item=>['women','youth_women','foreign_women'].includes(item.type)))

        }
      }
    },
    players_is_all_checked(players){
        return players.length === players.filter(item=>item.selected).length
    },
    async getMatchesOptions() {
      const response = await getTeamMatches(this.currentTeam)
      if(response.status === 200) {
        if(response.data.success){
          const matches = response.data.matches.sort(utils.compareFnDate)
          this.competitions = this.group(matches, 40)
          this.displayed_competitions = this.competitions
          this.handleSelection(this.default_value)
          this.competitions_checked = this.competitions_is_all_checked(this.displayed_competitions)
        }
      }
    },
    competitions_is_all_checked(competitions) {
      let flattenedArr = [].concat(...competitions)
      return flattenedArr.length === flattenedArr.filter(item=>item.selected).length
    },
    handleConfirm(){
      this.$router.push('/table')
    },

    async handleItemSelect(key, item){
      // console.log(key,item)
      if (key === 'player') {
        const postData = {
          player_id: item.player_id,
          selected: !item.selected,
        }
        const response = await updateTeamPlayerSelection(this.currentTeam, {data:postData})
        if (response.status === 200) {
          if (response.data.success) {
            item.selected = !item.selected
            this.men_players_checked = this.players_is_all_checked(this.males)
            this.women_players_checked = this.players_is_all_checked(this.females)
          }
        }
      }else if (key==='match') {
        const postData = {
          match_id: item.match_id,
          selected: !item.selected,
        }
        const response = await updateTeamMatchSelection(this.currentTeam, {data:postData})
        if (response.status === 200) {
          if (response.data.success) {
            item.selected = !item.selected
            this.competitions_checked = this.competitions_is_all_checked(this.displayed_competitions)
          }
        }
      }
    },
    group(array, length){
      let index = 0
      const res = []
      while(index<array.length){
        res.push(array.slice(index, index+=length))
      }
      return res
    },
    handleSelection(value) {
      // console.log(`selected ${value}`)
      if(value === 'all') {
        this.year = 'all'
        // this.selectCompetitions()
        this.displayed_competitions = this.competitions
      }
      else {
        if(value === '2023') {
          this.year = '2023'
          // this.selectCompetitions()
        }
        else if(value === '2024') {
          this.year = '2024'
          // this.selectCompetitions()
        }else if(value === '2025') {
          this.year = '2025'
          // this.selectCompetitions()
        }else if(value === '2026') {
          this.year = '2026'
          // this.selectCompetitions()
        }else {
          this.year = value
        }
        let tmp = []
        let flattenedArr = [].concat(...this.competitions)
        for(let i = 0; i < flattenedArr.length; i++) {
          if(flattenedArr[i].start_date[0] === parseInt(this.year)) {
            tmp.push(flattenedArr[i])
          }
        }
        this.displayed_competitions = this.group(tmp, 40)
      }
    },
    // onCheckAllCompetitionsChange(value) {
    //   // console.log(`checked ${value.target.checked}`)
    //   this.competitions_checked = value.target.checked
    //   this.selectCompetitions()
    // },
    onCheckAllCompetitionsChange() {
      this.competitions_checked = !this.competitions_checked
      this.selectCompetitions()
    },
    async selectCompetitions() {
      // console.log(this.displayed_competitions)
      if(this.year === 'all') {
        const response1 = await updateAllCompetitionsSelection(this.currentTeam, this.competitions_checked, '2023')
        const response2 = await updateAllCompetitionsSelection(this.currentTeam, this.competitions_checked, '2024')
        const response3 = await updateAllCompetitionsSelection(this.currentTeam, this.competitions_checked, '2025')
        const response4 = await updateAllCompetitionsSelection(this.currentTeam, this.competitions_checked, '2026')

        if(response1.status === 200 && response2.status === 200 && response3.status === 200&& response4.status === 200) {
          if(response1.data.success && response2.data.success && response3.data.success&& response4.data.success ) {
            let tmp = this.displayed_competitions
            for(let i = 0; i < tmp.length; i++) {
              for(let j = 0; j < tmp[i].length; j++) {
                tmp[i][j].selected = this.competitions_checked
              }
            }
            this.displayed_competitions = tmp
          }
        }
      }
      else {
        const response = await updateAllCompetitionsSelection(this.currentTeam, this.competitions_checked, this.year)
        if(response.status === 200) {
          if(response.data.success) {
            let tmp = this.displayed_competitions
            for(let i = 0; i < tmp.length; i++) {
              for(let j = 0; j < tmp[i].length; j++) {
                if(tmp[i][j].start_date[0] === parseInt(this.year)) {
                  tmp[i][j].selected = this.competitions_checked
                }
              }
            }
            this.displayed_competitions = tmp
          }
        }
      }
    },

    onCheckMenPlayersChange() {
      this.men_players_checked = !this.men_players_checked
      this.selectPlayers('men')
    },
    onCheckWomenPlayersChange() {
      this.women_players_checked = !this.women_players_checked
      this.selectPlayers('women')
    },
    async selectPlayers(gender) {
      if(gender === 'men') {
        const response = await updateAllPlayersSelection(this.currentTeam, this.men_players_checked, 'men')
        if(response.status === 200) {
          if(response.data.success) {
            let tmp = null
            tmp = this.males
            for(let i = 0; i < tmp.length; i++) {
              tmp[i].selected = this.men_players_checked
            }
            this.males = tmp
          }
        }
      }
      else if(gender === 'women') {
        const response = await updateAllPlayersSelection(this.currentTeam, this.women_players_checked, 'women')
        if(response.status === 200) {
          if(response.data.success) {
            let tmp = null
            tmp = this.females
            for(let i = 0; i < tmp.length; i++) {
              tmp[i].selected = this.women_players_checked
            }
            this.females = tmp
          }
        }
      }
    },
  }

}
</script>
<style lang="less">
.retired-athlete {
  color: #999; /* 设置为灰色 */
}
.view-list {
  height: calc(100vh - 66px);
  width: 100vw;
  overflow: auto;
  position: relative;
  background-image: url('~@/assets/background.png');
  background-repeat: repeat;
  background-size: 600px 600px;
  padding: 37px 60px;

  .comp-list {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    height: calc(100% - 100px);
    width: 100%;
  }

  .footer {
    margin-top: 30px;
    .btn{
      width: 494px;
      height: 60px;
      background: #0072BE;
      font-family: 'Microsoft YaHei UI';
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 25px;
      text-align: center;
      letter-spacing: -0.015em;
    }
  }

  .list-box {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    padding: 0 10px;
  }


  .list {
    height: 100%;
    overflow: hidden;
    &.competition {
      width: calc(100vw - 420px);
    }
    &.athlete {
      min-width:  130px;
      width: 10vw;
    }

    .competition-title {
      font-family: 'Microsoft YaHei UI';
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      /* or 120% */
      padding: 15px 20px;
      text-align: center;
      letter-spacing: -0.015em;
      // border-bottom: 6px solid #00375B;
      margin-left: 450px;
    }

    .player-title {
      font-family: 'Microsoft YaHei UI';
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      /* or 120% */
      padding: 15px 5px;
      text-align: center;
      letter-spacing: -0.015em;
    }

    .box-border {
      display: flex;
      flex-flow: row;
      border-bottom: 6px solid #00375B;
    }

    .list-item {
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      // height: 24px;
      margin-top: 11px;
      padding: 5px 8px;
      align-items: center;
      &:hover {
        background: rgba(0, 114, 190, 0.1);
        cursor: pointer;
      }
      .name {
        font-family: 'Microsoft YaHei UI';
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 24px;
        /* or 120% */
        letter-spacing: -0.015em;
        color: #000000;
        &.athlete{
          color: #00375B;
        }
      }
      .time {
        font-family: 'Microsoft YaHei UI';
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 24px;
        text-align: left;
        letter-spacing: -0.015em;
        color: #7a7a7a;
      }
      .icon {
        width: 18px;
        height: 18px;
      }
    }
  }

  .list-content.competition {
    width: 50%;
    min-width: 400px;
    margin-right: 30px;
  }

  .list + .list {
    margin-left:45px;
  }

  .scroll-box {
    height: calc(100% - 90px);
    overflow: auto;
    &::-webkit-scrollbar {
      height: 4px;
      width: 10px;
    }

    &::-webkit-scrollbar-track {
      background: rgb(239, 239, 239);
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background: #bfbfbf;
      border-radius: 6px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #333;
    }

    &::-webkit-scrollbar-corner {
      background: transparent;
    }
  }

  .select-competitions {
    // position: absolute;
    // top: 47px;
    // left: 1005px;
    margin-left: 5px;
    margin-top: 10px;
    // width: 100px;
    height: 35px;
    border: 2px solid #00375B;
    border-radius: 6px;
  }

  .all-competitions {
    // position: absolute;
    // top: 45px;
    // left: 1420px;
    margin-left: 300px;
  }

  .select-checkbox {
    display: flex;
    flex-flow: row;
    margin-top: 15px;
  }

  .select-text {
    font-size: 15px;
  }

  .select-icon {
    width: 18px;
    height: 18px;
    margin-right: 5px;
    margin-top: 2px;
    cursor: pointer;
  }

}

</style>
